<template>
  <h6 class="element-header">
    Betreutes Wohnen
  </h6>

  <div>
    <h5 class="form-header">Berichtsportale:</h5>

    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12 text-start">
        <p style="margin-bottom: 5px;">
          FACHKRAFTE - {{ coaching.specialistFullName }}
        </p>
        <p>
          Einheiten erledigt: {{ formatNumber(unitsDoneBySpecialist) }} &nbsp; - &nbsp;
          Es verbleiben noch {{ formatNumber(unitsLeftToBeDone) }}
          Einheiten, um 70 % zu erreichen
        </p>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12  text-md-end">
        <p style="margin-bottom: 5px;">
          ASSISTENZKRÄFTE - {{ coaching.supervisorFullName }}
        </p>
        <p>
          Einheiten erledigt:
          {{ formatNumber(coaching?.unitsDoneBySupervisor || 0) }}
        </p>
      </div>
    </div>

    <div class="progress mb-4">
      <div
          class="progress-bar"
          role="progressbar"
          :aria-valuemax="100"
          :aria-valuemin="0"
          :aria-valuenow="coaching?.specialistPercentUnitsDone"
          :style="progressBarStyle(coaching?.specialistPercentUnitsDone)">
        <span v-if="coaching?.specialistPercentUnitsDone > 0">
          {{ coaching?.specialistPercentUnitsDone }}%
        </span>
      </div>
      <span style="color: white; height: 100%; border-radius: 3px">|</span>
      <div
          class="progress-bar"
          role="progressbar"
          :aria-valuemax="100"
          :aria-valuemin="0"
          :aria-valuenow="coaching?.supervisorPercentUnitsDone"
          :style="progressBarStyle(coaching?.supervisorPercentUnitsDone)">
         <span v-if="coaching?.supervisorPercentUnitsDone > 0">
          {{ coaching?.supervisorPercentUnitsDone }}%
        </span>
      </div>
    </div>

    <div class="row m-0 portal_user_data p-3" style="font-size: 15px">
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <div class="col-sm-5 col-6 mb-1"><strong>Vorname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.firstName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Nachname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.lastName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>JC / AA Nummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.aaNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Versicherungsnr:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.insuranceNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Email:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic text-break">{{ coaching?.unemployed?.email || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Telefonnummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.unemployed?.phone || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Sachbearbeiter:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">{{ coaching?.coaching?.clerk || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Adresse:</strong></div>
          <div class="col-sm-7 col-6 mb-1 fst-italic">
            {{ coaching?.unemployed?.address }},
            {{ coaching?.unemployed?.zip }} {{ coaching?.unemployed?.city }}
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
        <div
            v-for="(exports, index) in exportRows"
            :key="index"
            class="d-flex flex-wrap justify-content-lg-end justify-content-center"
            :class="{ 'mt-2': index > 0 }">
          <div
              v-for="item in exports"
              :key="item.url"
              class="portal-export-item text-center"
              style="width: 105px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export portal-export-button w-100 d-flex flex-column align-items-center p-1"
               @click="downloadFile(item.url, undefined, item.withFilters ? filtersFormated : undefined, item.type === 'pdf' ? undefined : false)">
              <img :src="item.type === 'pdf' ? pdfIcon : excelIcon"
                   :alt="item.type === 'pdf' ? 'PDF' : 'Excel'"
                   :style="{ width: item.type === 'pdf' ? '48px' : '42px', height: 'auto', objectFit: 'contain' }"
                   class="mb-1"/>
              <p class="mb-0 text-dark fw-bold" style="font-size: 12px; line-height: 1.15; white-space: normal;">
                {{ item.label }}
              </p>
            </a>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4 border-top pt-3">
        <div class="d-flex flex-column align-items-end">
          <div class="h5 mb-0">
            <strong>{{ calculatedUnits?.unitsDone }}</strong> / {{ calculatedUnits?.maxUnits }} Einheiten
          </div>
          <div v-if="calculatedUnits?.unitsLeft < 3" class="text-danger fw-bold middle mt-1">
            Sie haben noch {{ calculatedUnits.unitsLeft.toFixed(2) }} offene Einheiten
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { downloadFile } from '@/shared/functions';
import { computed, defineProps, toRefs } from 'vue';
import pdfIcon from '@/assets/img/pdf_icon_version4.png';
import excelIcon from '@/assets/img/excel_icon.jpg';

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  calculatedUnits: {
    type: Array,
    required: true,
  },
  filtersFormated: {
    type: Object,
    required: false,
  },
});

const coaching = toRefs(props)[ 'coaching' ];

const exportRows = computed(() => {
  const id = coaching.value?.id;
  const hasDigitalSignature = !!coaching.value?.digitalSignature;
  const baseUrl = '/portal/assisted-living-coaching';

  const pdfExports = [
    { type: 'pdf', label: 'Abschlussbericht (Kurz)', url: `${baseUrl}/final-report-short-version-pdf/${id}` },
    { type: 'pdf', label: 'Abschlussbericht (Lang)', url: `${baseUrl}/final-report-long-version-pdf/${id}` },
  ];
  const excelExports = [];

  if (hasDigitalSignature) {
    pdfExports.push(
        { type: 'pdf', label: 'Anwesenheit', url: `${baseUrl}/meeting-list-pdf/${id}`, withFilters: true },
        { type: 'pdf', label: 'Leistungsnachweis', url: `${baseUrl}/performance-record-pdf/${id}`, withFilters: true },
    );
    excelExports.push(
        { type: 'excel', label: 'Anwesenheit', url: `${baseUrl}/meeting-list-excel/${id}`, withFilters: true },
        { type: 'excel', label: 'Leistungsnachweis', url: `${baseUrl}/performance-record-excel/${id}`, withFilters: true },
    );
  }

  return [ pdfExports, excelExports ].filter(row => row.length > 0);
});

const specialistFullName = computed(() => {
  if (coaching.value?.specialist) {
    return coaching.value?.specialist?.firstName + ' ' + coaching.value?.specialist?.lastName;
  } else {
    return 'Keine Daten';
  }
});

const supervisorFullName = computed(() => {
  if (coaching.value?.supervisor) {
    return coaching.value?.supervisor?.firstName + ' ' + coaching.value?.supervisor?.lastName;
  } else {
    return 'Keine Daten';
  }
});

const unitsDoneBySpecialist = computed(() =>
    (props.coaching?.unitsDoneBySpecialist || 0) +
    (props.coaching?.unitsDoneByEmergencySupervisor || 0),
);

const unitsDoneBySupervisor = computed(() =>
    props.coaching?.unitsDoneBySupervisor || 0,
);

const unitsLeftToBeDone = computed(() =>
    2.33 * unitsDoneBySupervisor.value - unitsDoneBySpecialist.value,
);

const formatNumber = (value) =>
    new Intl.NumberFormat('de-DE',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    ).format(value);

const fontColor = computed(() =>
    props.progressBarColor === '#FFAC1C!important' ? 'black' : 'white',
);

const progressBarStyle = (width) => ({
  width: `${width}%`,
  backgroundColor: props.progressBarColor,
  color: fontColor.value,
  fontSize: '12px',
});

</script>

<style scoped>

</style>